export default __webpack_public_path__ + "static/media/balance-wellness-auto-detect.c3464bf4.md";